import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalConfig, loginRequest, tokenRequest } from "./config";
import { getMsalInstance, getMsalInstanceSync } from "./msalInstance";
import admin from "@/apiCallers/promise_handler_db/admin";
import { store } from '@/vuex/store'
import { clearAllParams } from "../../router/queryHandler/index"

let username = "";

/**
 * Initialize MSAL and handle any pending redirect response.
 * Must be called once at app startup before using other MSAL APIs.
 */
async function initializeMsal() {
    const myMSALObj = await getMsalInstance();
    try {
        const response = await myMSALObj.handleRedirectPromise();
        await handleResponse(response);
    } catch (error) {
        console.error(error);
    }
}

// Kick off initialization
const msalReady = initializeMsal();

/**
 * Synchronous login check - returns false if MSAL not yet initialized.
 * Safe for use in Vue computed properties.
 */
function isLoggedIn() {
    const instance = getMsalInstanceSync();
    if (!instance) return false;
    const currentAccounts = instance.getAllAccounts();
    return currentAccounts.length > 0;
}

function selectAccount(myMSALObj) {
    const currentAccounts = myMSALObj.getAllAccounts();

    if (currentAccounts.length === 0) {
        return;
    } else if (currentAccounts.length > 1) {
        console.warn("Multiple accounts detected.");
    } else if (currentAccounts.length === 1) {
        username = currentAccounts[0].username;
    }
}

async function handleResponse(response) {
    if (response !== null) {
        store.state.login_load = true;
        store.state.aToken = response.accessToken;
        await admin.logUserLogin(response.uniqueId)
            .catch((er) => {
                console.error("Unable to log user login");
            }).then((resp) => {
                username = response.account.username;
                console.log(resp)
                window.location.href = resp.data
            });

    } else {
        const myMSALObj = await getMsalInstance();
        selectAccount(myMSALObj);
    }
}

async function signIn() {
    await msalReady;
    const myMSALObj = await getMsalInstance();

    clearAllParams();
    await myMSALObj.loginRedirect(loginRequest).then((resp) => {
        // location.href("http://localhost:8080/")
    })
}

async function signOut() {
    await msalReady;
    const myMSALObj = await getMsalInstance();

    clearAllParams();

    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        postLogoutRedirectUri: msalConfig.auth.redirectUri,
    };

    myMSALObj.logoutRedirect(logoutRequest);
}

async function getTokenRedirect(forceRefresh = false) {
    await msalReady;
    const myMSALObj = await getMsalInstance();

    selectAccount(myMSALObj);

    const currentAccounts = myMSALObj.getAllAccounts();
    if (currentAccounts.length === 0) {
        console.warn('[getTokenRedirect] No accounts found');
        return null;
    }

    let request = {
        ...tokenRequest,
        account: myMSALObj.getAccountByUsername(username) || currentAccounts[0],
        forceRefresh: forceRefresh
    };

    try {
        const response = await myMSALObj.acquireTokenSilent(request);
        console.log('[getTokenRedirect] Token acquired silently');
        return response;
    } catch (error) {
        console.warn("[getTokenRedirect] Silent token acquisition failed:", error.message);

        if (error instanceof InteractionRequiredAuthError) {
            console.log('[getTokenRedirect] Interaction required, redirecting...');
            try {
                await myMSALObj.acquireTokenRedirect(request);
                return null;
            } catch (redirectError) {
                console.error('[getTokenRedirect] Redirect failed:', redirectError);
                throw redirectError;
            }
        } else if (error.name === 'BrowserAuthError' || error.errorCode === 'no_tokens_found') {
            console.log('[getTokenRedirect] No tokens found, need full re-authentication');
            try {
                await myMSALObj.acquireTokenRedirect({
                    ...request,
                    prompt: 'login'
                });
                return null;
            } catch (redirectError) {
                console.error('[getTokenRedirect] Re-auth redirect failed:', redirectError);
                throw redirectError;
            }
        } else {
            if (!forceRefresh) {
                console.log('[getTokenRedirect] Retrying with force refresh...');
                return getTokenRedirect(true);
            }

            console.error('[getTokenRedirect] Token acquisition failed after retry:', error);
            window.dispatchEvent(new CustomEvent('auth-error', {
                detail: { error: error, message: 'Failed to acquire authentication token. Please try logging in again.' }
            }));
            throw error;
        }
    }
}

function seeProfile() {
    getTokenRedirect(loginRequest)
        .then(response => {
            // callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}


function readMail() {
    getTokenRedirect(tokenRequest)
        .then(response => {
            callMSGraph(graphConfig.graphMailEndpoint, response.accessToken, updateUI);
        }).catch(error => {
            console.error(error);
        });
}
export { signIn, getTokenRedirect, isLoggedIn, signOut, msalReady }
